import { render, staticRenderFns } from "./3.vue?vue&type=template&id=4ab92e64&scoped=true&"
var script = {}
import style0 from "./3.vue?vue&type=style&index=0&id=4ab92e64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab92e64",
  null
  
)

export default component.exports